import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DownloadAttachmentModalComponent } from '@app/admin/manage/modals/download-attachment-modal/download-attachment-modal.component';
import { AdminRequestServices } from '@services/admin/admin-request.service';
import { getModalConfig, ModalSize } from '@utility/modal-helper';
import { switchMap, take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AttachmentService {
    private readonly adminRequestServices = inject(AdminRequestServices);
    private readonly dialog = inject(MatDialog);

    public downloadAttachment(
        requestId: number,
        attachmentInfo: { attachmentId: number; attachmentName: string }
    ): void {
        this.adminRequestServices
            .getTravelRequestAttachmentUri(requestId, attachmentInfo.attachmentId)
            .pipe(
                switchMap((url) =>
                    this.dialog
                        .open<DownloadAttachmentModalComponent, DownloadAttachmentModalComponent['data'], void>(
                            DownloadAttachmentModalComponent,
                            {
                                data: { dataSourceUrl: url.toString(), attachmentName: attachmentInfo.attachmentName },
                                ...getModalConfig(ModalSize.Small),
                            }
                        )
                        .afterClosed()
                ),
                take(1)
            )
            .subscribe();
    }
    public readonly travelRequestAttachmentName = 'travel-request-attachments';
}
